(function($) {

    /**
     * The way this works is to create an extra hidden field with the name of the input this matches (ie those with class 'time-picker'). The matched input is then
     * renamed and all changes are propagated to the hidden field. It also captures the date changes from the datepicker plugin and is somewhat reliant on the current
     * naming conventions that uses..
     *
     * It also assumes the datepicker has had its 'alt-field-postfix' property set to '-dateonly', to avoid a clash with managing the hidden fields..
     *
     * @param options - Optional override of the default options (see below)
     */
	$.fn.msxijtimepicker = function(options) {
		// build main options before element iteration
		var opts = $.extend(true, {}, $.fn.msxijtimepicker.defaults, options);

		return this.each(
            function() {
                var $this = $(this);
                var id = $this.attr('id');
                // build element specific options
                var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;

                var escapedAltFieldId = id.replace(/[\[\]\.]/g, "__");
                // Append timestamp to the ID to make sure it is unique on the page, in case we are inside a dialog,
                // otherwise if multiple dialogs are opened containing the same form then the wrong field gets updated
                escapedAltFieldId = escapedAltFieldId + '-' + new Date().getTime();
                
                var datePickerAltFieldId = $this.siblings(':hidden').attr('id');

                // Add listener to to timepicker set the time on the hidden field
                eOpts = $.extend(true, {}, eOpts, {
                    'onClose': function()
                                {
                                    var timeValue = $this.val();
                                    var dateValue = $('#'+datePickerAltFieldId).val();
                                    if (dateValue === undefined)
                                    {
                                        $('#'+escapedAltFieldId).val(timeValue).trigger('change');
                                    }
                                    else
                                    {
                                        $('#'+escapedAltFieldId).val(dateValue+' '+timeValue).trigger('change');
                                    }
                                    // Timepicker changes time value after the focusout event has fired
                                    // so placeholder class needs manually removing.
                                    $this.removeClass("placeholder");
                                }
                });

                var name = $this.attr('name');
                $this.attr({
                               'id': escapedAltFieldId + '-time-picker',
                               'name': name + '-time-picker'
                           });
                var $altField = $('<input type="hidden" />');
                $altField.attr({
                                   'id': escapedAltFieldId,
                                   'name': name
                               });
                $this.timepicker(eOpts);

                // Read the time value from the input box to make sure that the text edited by user is not missed out.
                $this.keyup(function(){
                    var dateValue = $('#'+datePickerAltFieldId).val();
                    var timeValue = $this.val();
                    if(timeValue === 'hh:mm')
                    {
                        timeValue = '';
                    }

                    if (dateValue === undefined)
                    {
                        $('#' + escapedAltFieldId).val(timeValue).trigger('change');
                    }
                    else
                    {
                        $('#' + escapedAltFieldId).val(dateValue + ' ' + timeValue).trigger('change');
                    }
                });

                // temp disable the time-picker field as we don't need it to be submitted with the form
                $this.excludeSubmit();

            // Add listener to the date picker to set the date on the hidden field
                var dateInputPicker = $this.siblings('#'+datePickerAltFieldId+'-date-picker');

                var datePickerOnClose = dateInputPicker.datepicker( 'option' , 'onClose');
                dateInputPicker.datepicker( 'option' , 'onClose', function(dateValue) {
                    if(dateValue!='')
                    {
                        var timeValue=$('#'+escapedAltFieldId + '-time-picker').val();
                        if(timeValue === 'hh:mm')
                        {
                            timeValue = '';
                        }
                        var dateParsed = $('#'+datePickerAltFieldId).val(); // Use the pre parsed date in the hidden field created by the msx.datepicker
                        if (dateParsed === undefined)
                        {
                            $('#' + escapedAltFieldId).val(timeValue).trigger('change');
                        }
                        else
                        {
                            $('#' + escapedAltFieldId).val(dateParsed + ' ' + timeValue).trigger('change');
                        }
                        if (datePickerOnClose) {
                            // call default onSelect
                            datePickerOnClose.call(this, dateValue);
                        }
                    }

                } );


                // read date value from input box and set it to the hidden field so that when user blanks out the value it get reflected on screen.
                dateInputPicker.keyup(function ()
                {
                    var dateValue = $('#'+datePickerAltFieldId).val();
                    if (dateValue === '')
                    {
                        var timeValue=$('#'+escapedAltFieldId + '-time-picker').val();
                        if(timeValue === 'hh:mm')
                        {
                            timeValue = '';
                        }
                        $('#' + escapedAltFieldId).val(timeValue).trigger('change');
                    }
                });

            // And now default the hidden fields value to the current date and time.
                var dateInputBox = $this.siblings('#'+datePickerAltFieldId);
                var dateValue = dateInputBox.val();

                if (dateValue === undefined || dateValue === '')
                {
                    var value = $this.val();
                    if (value.match('(\\d{4}-\\d{2}-\\d{2} )?\\d{2}:\\d{2}')) {
                        $altField.val(value);
                    }
                }
                else
                {
                    $altField.val(dateValue+' '+$this.val());
                }
                $altField.insertBefore($this);

                if(eOpts['tracked-date-time'])
                {
                    var $trackedDate = $this.closest('.form').find('input[name=' + eOpts['tracked-date-time'] + ']');
                    if ($trackedDate.length == 0) {
                        //Find the start date time picker for inputDateTimeRange
                        $trackedDate = $this.closest('.form-time-period-for-date').find('.' + eOpts['tracked-date-time']);
                    }

                    if ($trackedDate !== undefined) {
                        // Listen to changes on tracked date time and update this date time accordingly
                        $trackedDate.data('value', $trackedDate.val()).bind('change', function() {
                            var previousDate = parseDateTime($trackedDate.data('value'));
                            var nextDate = parseDateTime($trackedDate.val());
                            var thisDate = parseDateTime($altField.val());
                            if (previousDate && nextDate  && thisDate) {
                                var diff = nextDate.getTime() - previousDate.getTime();
                                if (diff !== 0) {
                                    dateInputPicker.datepicker("option", "minDate", null);
                                    var newDate = new Date(thisDate.getTime() + diff);
                                    var $datepicker = $('#' + datePickerAltFieldId + '-date-picker');
                                    //date picker might be empty if this timepicker is with inputDateTimeRange
                                    if ($datepicker.length > 0 && (thisDate.toDateString() != newDate.toDateString())) {
                                        setDatePickerDateAndTriggerOnSelect($datepicker, newDate);
                                    }
                                    var timeValue = '';
                                    if ($('#' + escapedAltFieldId + '-time-picker').val() !== 'hh:mm') {
                                        if (newDate.getHours() > nextDate.getHours() || (newDate.getHours() == nextDate.getHours() && newDate.getMinutes() > nextDate.getMinutes())) {
                                            timeValue = padTime(newDate.getHours()) + ":" + padTime(newDate.getMinutes());
                                        } else {
                                            // set value to end of the day if the new time has been pushed to next day.
                                            timeValue = "23:55";
                                        }
                                        $this.timepicker('setTime', timeValue);

                                        /**
                                         * setTime on timepicker will invoke _rebindDialogEvents which will bind the time selection panel to end time picker.
                                         * Therefore manually calling _updateTimepicker on start time picker to bind the time selection panel back.
                                         */
                                        $.timepicker._updateTimepicker($.timepicker._getInst($trackedDate[0]));
                                    }
                                    // Now sync to date time field
                                    var dateValue = $('#' + datePickerAltFieldId).val(); // Use the pre parsed date in the hidden field created by the msx.datepicker
                                    //date value will be undefined if this timepicker does not have an associated date picker.
                                    var value = dateValue !== undefined ? (dateValue + ' ' + timeValue) : timeValue;
                                    $('#' + escapedAltFieldId).val(value).trigger('change');
                                    dateInputPicker.datepicker("option", "minDate", nextDate);
                                }
                            }
                            $trackedDate.data('value', $trackedDate.val());
                        });
                    }
                }
            }
        );

	};
	//
	// plugin defaults
	//
	$.fn.msxijtimepicker.defaults = {
        showPeriodLabels: false,
        defaultTime: ''
    };

    function parseDateTime(dateTimeStr) {
        // Using DateJS parse function
        return Date.parse(dateTimeStr);
    }

    function padTime(i)
    {
        if(i < 10)
        {
            i = "0" + i;
        }
        return i;
    }

    function setDatePickerDateAndTriggerOnSelect($datepicker, date) {
        var existingDate = $datepicker.datepicker("getDate");
        if (existingDate != undefined && existingDate.getTime() != date.getTime()) {
            $datepicker.datepicker("setDate", date);
            // calling setDate does not trigger the onSelect callback, which is necessary to keep inputs in sync
            var inst = $.datepicker._getInst($datepicker[0]);
            $.datepicker._get(inst, 'onClose').apply(inst.input[0], [date, inst]);
        }
    }

})(jQuery);